import { Link } from "react-router-dom";
import { Tornado } from "lucide-react";

const About = () => {
  return (
    <div data-testid="about-page">
      <section className="border-b-2 border-[#1C1C1C] bg-[#1C1C1C] text-[#FDFBF7] grain relative overflow-hidden">
        <div className="max-w-4xl mx-auto px-6 md:px-12 py-24 md:py-32 relative">
          <Tornado className="w-12 h-12 text-[#D35400] mb-6" strokeWidth={2.5} />
          <h1 className="font-display text-6xl md:text-8xl leading-[0.9]">Born In The Heartland.</h1>
          <p className="text-xl text-[#C9C4BA] mt-6 max-w-2xl leading-relaxed">
            Tornado Alley Trading Co. is a vintage-inspired apparel brand built on Midwest grit and Kansas City pride.
          </p>
        </div>
      </section>

      <section className="max-w-4xl mx-auto px-6 md:px-12 py-20 space-y-12">
        <div>
          <h2 className="font-display text-5xl mb-4">Our Story</h2>
          <p className="text-lg text-[#4A4A4A] leading-relaxed">
            We started Tornado Alley Trading Co. with a simple idea: the places that make Kansas City special — the
            smokehouses, the dive bars, the jazz clubs, the fountains — deserve to be worn with pride. Every design is a
            love letter to a city that's bold, nostalgic, creative, and a little bit gritty. Just like us.
          </p>
        </div>
        <div>
          <h2 className="font-display text-5xl mb-4">Iconic KC</h2>
          <p className="text-lg text-[#4A4A4A] leading-relaxed">
            Our flagship collection, Iconic KC, is the heart of our monthly Tee Club. Each month we drop a new
            limited-run design celebrating a different piece of Kansas City culture — from world-famous BBQ to the
            birthplace of bebop. Subscribers get a fresh slice of KC history delivered straight to their door.
          </p>
        </div>
        <div>
          <h2 className="font-display text-5xl mb-4">Made To Last</h2>
          <p className="text-lg text-[#4A4A4A] leading-relaxed">
            Heavyweight cotton. Distressed screen prints. Garment-dyed colors that fade just right. We make apparel
            built to ride out every Midwest season — and look better with every wash.
          </p>
        </div>
        <div className="border-2 border-[#1C1C1C] hard-shadow bg-[#D35400] text-white p-8 md:p-12 text-center">
          <h2 className="font-display text-5xl mb-3">Wear KC History</h2>
          <p className="text-lg mb-6 text-white/90">Join the Tee Club and rep the heartland every single month.</p>
          <Link to="/tee-club" className="bg-[#1C1C1C] text-white px-8 py-4 font-bold uppercase tracking-widest inline-block hover:bg-black transition" data-testid="about-join-club">
            Join the Tee Club
          </Link>
        </div>
      </section>
    </div>
  );
};

export default About;
